<template>
  <section class="container d-flex flex-column mt-3">
    <header>
      <span class="h6">
        <router-link to="/">Início</router-link>
        / Regras
      </span>

      <h3 class="text-center my-5">Regras</h3>
    </header>

    <section>
      <h4 class="mb-3">Regras Gerais</h4>

      <p class="text-justify">
        - Crie os personagens no
        <router-link to="/generator">Gerador de Campo e Personagens</router-link>.
        Se cada jogador for jogar com mais de um personagem, gere um personagem por vez para cada jogador.
      </p>

      <p class="text-justify">
        - Crie um campo de batalha no <router-link to="/generator">Gerador de Campo e Personagens</router-link>.
        Você pode usar o campo da forma que foi gerado ou apenas utilizar os terrenos e montar o Campo de Batalha
        com um formato personalizado. Não podem existir áreas que não se conectem com pelo menos uma outra área.
        Dê um número sequencial para cada área do Campo de Batalha. Cada área é uma grade de 3x3.
      </p>

      <p class="text-justify">
        - Para definir onde um personagem irá começar o jogo, deve se verificar qual o número de áreas o Campo de Batalha
        possui e pegar as Fichas de Posição (numeradas de 1 a 16) de acordo com a quantidade de áreas.
      </p>

      <p class="text-justify">
        - Para cada personagem, embaralhe as fichas e o jogador que controla o personagem deve escolher uma delas.
        O jogador deve escolher um dos 9 quadrados dentro da área que a Ficha de Posição indica (as áreas que foram
        numeradas quando o Campo de Batalha foi criado).
      </p>

      <p class="text-justify">
        - O máximo de personagens em uma mesma área no início do jogo é 2, caso um terceiro personagem tire uma Ficha de
        Posição onde já tenha 2 personagens, o jogador deve tirar uma outra Ficha de Posição.
      </p>

      <p class="text-justify">
        - Para definir a ordem de jogo dos personagens, para cada personagem lance 1d20 e some o resultado à Agilidade.
        A ordem será de acordo com o resultado, do maior para o menor.
      </p>
    </section>

    <section class="mt-5">
      <h4 class="mb-3">Habilidades</h4>

      <p class="text-justify">
        - As habilidades são divididas em três grupos: Habilidades de Raça, Habilidades de Classe e Habilidades Especiais.
      </p>

      <p class="text-justify">
        - As habilidades são divididas em cinco tipos: Habilidades de Ataque, Habilidades de Defesa, Habilidades de Suporte, Habilidades de Mudança e Habilidades Passivas.
      </p>

      <p class="text-justify">
        - Habilidades de Raça podem ser usadas o número de vezes descrito na habilidade.
      </p>

      <p class="text-justify">
        - Habilidades de Classe necessitam de PHs para serem usadas.
      </p>

      <p class="text-justify">
        - Habilidades Passivas ficam ativas o tempo todo durante o jogo.
      </p>
    </section>

    <section class="mt-5">
      <h4 class="mb-3">Ações</h4>

      <p class="text-justify">
        - Em seu turno, os personagens podem fazer até duas ações dentre as ações abaixo:
        <ul>
          <li>Trocar arma (entre arma primária e secundária)</li>
          <li>Movimentar</li>
          <li>Atacar normal ou utilizando uma Habilidade de Ataque</li>
          <li>Utilizar uma Habilidade de Suporte</li>
        </ul>
      <!-- eslint-disable-next-line -->
      </p>

      <p class="text-justify">
        - Qualquer ação sem ser "Movimentar" termina o turno do personagem imediatamente.
      </p>

      <p class="text-justify">
        - Quando um personagem é atacado ele pode utilizar uma Habilidade de Defesa caso queira
        e tenha PHs suficientes.
      </p>
    </section>

    <section class="mt-5">
      <h4 class="mb-3">Combate</h4>

      <p class="text-justify">
        - Um personagem morre quando seu PV chega a 0, exceto caso uma regra específica diga o contrário.
      </p>

      <p class="text-justify">
        - Para calcular o Valor de Ataque use a seguinte regra:<br />
        <strong>Valor do Atributo de Ataque + Dado de Arma + Bônus de Ataque</strong>
      </p>

      <p class="text-justify">
        - Para calcular o Valor de Defesa use a seguinte regra:<br />
        <strong>Valor do Atributo de Defesa + Dado de Armadura + Bônus de Defesa</strong>
      </p>

      <p class="text-justify">
        - Para calcular Valor do Dano use a seguinte regra:<br />
        <strong>(Valor de Ataque do atacante – Valor de Defesa do defensor)</strong>
      </p>

      <p class="text-justify">
        - O Valor do Dano mínimo é 1, mesmo que o Valor de Ataque seja menor que o Valor de Defesa.
        Depois de calculado o Valor do Dano, acrescente o <strong>Bônus de Dano</strong>.
      </p>

      <p class="text-justify">
        - O Atributo de Ataque é definido pela arma que está sendo utilizada.
      </p>

      <p class="text-justify">
        - O Atributo de Defesa é definido pela seguinte regra:
        <ul>
          <li>Ataque com Atributo Força = Defesa com Atributo Resistência</li>
          <li>Ataque com Atributo Destreza = Defesa com Atributo Agilidade</li>
          <li>Ataque com Atributo Sabedoria = Defesa com Atributo Inteligência</li>
        </ul>
      </p>
    </section>
  </section>
</template>

<script>
export default {
  name: 'rules'
}
</script>
